module.exports = __webpack_public_path__ + "static/media/christy_biju.f26e8157.png";